function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 10.324h-6.689v-.22a.61.61 0 00-.598-.62h-.39v2.045h.39a.61.61 0 00.598-.62v-.303H32v-.282zM16.186 5.5h-.597v.73a1.634 1.634 0 00-.332-.034c-.935 0-1.693.788-1.693 1.759 0 .737.435 1.3 1.058 1.63.38.2.607.42.696.868h.867c.423 0 .765-.356.765-.793V6.294c0-.439-.343-.794-.764-.794z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.613 11.58c-.402-.88-1.258-1.492-2.258-1.492a2.4 2.4 0 00-.763.138.928.928 0 00-.36.112l-3.71 2.04c-.009.005-.014.014-.021.018a.717.717 0 00-.224.184l-3.092 3.96a.6.6 0 00.852.144l2.783-2.443.423-.554c.27-.105 1.042-.41 1.834-.733l.348-.77.228.067-.127.52.003-.001-.06.235-.103.42-.006.001-.504 1.954a5.06 5.06 0 00-.139 1.716 1.85 1.85 0 00-.71.872c-.079.092-.15.194-.211.304-.193.347-1.853 3.406-2.556 4.697l-.607.09-6.058 2.343A.929.929 0 00.032 26.5l7.73-1.128c.455.09.913-.128 1.301-.596.525-.633 2.314-2.606 3.285-3.845l-.672-.105-.037-.243 1.145-.226 4.013-.814.03.184 2.468 6.206c.173.433.65.669 1.076.525l-1.392-8.197a1.27 1.27 0 00.001-.406c-.115-.68-.651-1.04-1.414-1.051-.446-.006-1.51-.034-2.646-.049l.824-3.192 7.531-2.462c.53-.165.668-.78.65-1.15 0 0-6.117 1.168-8.312 1.628z",
  fill: "currentColor"
})));